import {inject} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  RedirectCommand,
  Router,
  CanActivateFn
} from '@angular/router';
// import {Auth} from '@entities/auth/auth';
import {URL_LOGIN} from '@shared/utils/vars';
import {Logger} from '@shared/utils/logger';
import {saveLastRoute} from '@entities/navigation/nav';
import {UserStore} from '@library/entities/user/user.store';

/**
 *
 * @param route
 * @param state
 */
export const authUserGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  // const auth = inject(Auth);
  const router = inject(Router);
  const user = inject(UserStore);

  const isLogged = user.isLogged();

  Logger.log('ACCESS GUARD', state.url, isLogged);

  if (!isLogged) {
    const loginPath = router.parseUrl(URL_LOGIN);

    // loginPath.queryParams = {
    //   returnUrl: state.url
    // };
    saveLastRoute(state.url);

    return new RedirectCommand(loginPath);
  }

  return isLogged;
};

